import Player from '@vimeo/player';

enum VideoType {
    NATIVE = "native",
    VIMEO = "vimeo",
    YOUTUBE = "youtube",
    JWPLAYER = "jwplayer",
    NONE = "none"
}

export class VideoItem {
    container: HTMLElement;
    video: HTMLIFrameElement | HTMLVideoElement;
    videoType: string;
    videoSrc: string;
    playButton: HTMLButtonElement;
    videoObject: any;
    youtubeVideoPlayer: any;
    jwPlayerId: string;

    constructor(container: HTMLElement, youtubeVideoPlayer?: any) {
        if (youtubeVideoPlayer)
            this.youtubeVideoPlayer = youtubeVideoPlayer;
        this.container = container;
        this.video = this.youtubeVideoPlayer ? this.container.querySelector('iframe') : this.container.querySelector('[data-video]');
        this.videoType = this.container.getAttribute('data-video-type');
        this.videoSrc = this.video.getAttribute('data-src');
        this.playButton = this.container.querySelector('[data-video-play]') as HTMLButtonElement;
        // Get JW Player ID if it's a JW Player video
        if (this.videoType === VideoType.JWPLAYER) {

            this.jwPlayerId = this.video.getAttribute('data-jwplayer-id') || this.video.id;
        }
       
        this.initializeVideo();
    }

    playPause() {
        // Youtube Play and Pause
        if (this.videoType == VideoType.YOUTUBE) {
            const playerState = this.videoObject.getPlayerState();
            //// == 1 means it's playing
            if (playerState == 1) {
                this.videoObject.pauseVideo();
            }
            else {
                this.videoObject.playVideo();
                if (this.videoObject.isMuted())
                    this.videoObject.unMute();
            }
        }

        // Native Play and Pause
        if (this.videoType == VideoType.NATIVE) {
            if (this.videoObject.paused) {
                this.videoObject.play();
            }
            else {
                this.videoObject.pause();
            }
            this.videoObject.controls = true;
        }

        // Vimeo Play and Pause
        if (this.videoType == VideoType.VIMEO) {
            this.videoObject.getPaused().then((paused: boolean) => {
                if (paused) {
                    this.videoObject.play();
                }
                else {
                    this.videoObject.pause();
                }
            })
        }

        // JW Player Play and Pause
        if (this.videoType == VideoType.JWPLAYER) {
            const state = this.videoObject.getState();
            if (state === 'playing') {
                this.videoObject.pause();
            } else {
                this.videoObject.play();
                // Unmute if muted
                if (this.videoObject.getMute()) {
                    this.videoObject.setMute(false);
                }
            }
        }

        this.container.classList.add('media-item-playing');
    }

    initializeVideo() {
        if (!this.video.src) {

            // Native video initialization
            if (this.videoType == VideoType.NATIVE) {
                this.video = this.video as HTMLVideoElement;
                const videoSource = this.video.querySelector('source');
                if (videoSource) {
                    videoSource.src = this.videoSrc;
                    this.videoObject = this.video;
                    this.videoObject.load();
                    this.videoObject.controls = false;
                }
            }

            // Vimeo video initialization
            if (this.videoType == VideoType.VIMEO) {
                this.video.src = this.videoSrc;
                const vimeoPlayer = new Player(this.video, {});
                this.videoObject = vimeoPlayer;
            }

            // JW Player initialization
            if (this.videoType == VideoType.JWPLAYER) {
                // Check if jwplayer is available globally
                if (typeof (window as any).jwplayer !== 'undefined') {
                    const jwplayer = (window as any).jwplayer;

                    // Initialize JW Player with the container or use existing instance
                    if (this.jwPlayerId && jwplayer(this.jwPlayerId)) {
                        this.videoObject = jwplayer(this.jwPlayerId);
                    } else {

                        // Setup new JW Player instance
                        this.videoObject = jwplayer(this.video).setup({
                            file: this.videoSrc,
                            width: '100%',
                            height: '100%',
                            controls: false, // Start with controls disabled
                            autostart: false
                        });
                    }
                }  
            }
        }
        else {
            // Youtube initialization and handlers
            if (this.videoType == VideoType.YOUTUBE) {
                this.videoObject = this.youtubeVideoPlayer;
            }

            // JW Player initialization for existing iframe
            if (this.videoType == VideoType.JWPLAYER) {

                if (typeof (window as any).jwplayer !== 'undefined') {
                    const jwplayer = (window as any).jwplayer;
                    if (this.jwPlayerId && jwplayer(this.jwPlayerId)) {
                        this.videoObject = jwplayer(this.jwPlayerId);
                    }
                }
            }
        }

        //Activate Playbutton
        this.playButton.addEventListener('click', this.playPause.bind(this));
    }
}